import { Configuration, LogLevel } from '@azure/msal-browser';

/**
 * Configuration object for MSAL authentication
 */
const msalConfig: Configuration = {
	auth: {
		clientId: process.env.REACT_APP_AZURE_AD_B2C_CLIENT_ID || '',
		authority: process.env.REACT_APP_AZURE_AD_B2C_AUTHORITY || '',
		knownAuthorities: process.env.REACT_APP_AZURE_AD_B2C_KNOWN_AUTHORITIES
			? [process.env.REACT_APP_AZURE_AD_B2C_KNOWN_AUTHORITIES]
			: [],
		redirectUri: window.location.origin,
		postLogoutRedirectUri: window.location.origin,
		navigateToLoginRequestUrl: true,
	},
	cache: {
		cacheLocation: 'localStorage',
		storeAuthStateInCookie: false,
	},
	system: {
		loggerOptions: {
			loggerCallback: (level, message, containsPii) => {
				if (containsPii) {
					return;
				}
				switch (level) {
					case LogLevel.Error:
						console.error(message);
						break;
					case LogLevel.Info:
						console.info(message);
						break;
					case LogLevel.Verbose:
						console.debug(message);
						break;
					case LogLevel.Warning:
						console.warn(message);
						break;
				}
			},
			piiLoggingEnabled: false,
			logLevel: LogLevel.Warning,
		},
		windowHashTimeout: 60000,
		iframeHashTimeout: 6000,
		loadFrameTimeout: 0,
	},
};

/**
 * Request object for MSAL login
 */
export const loginRequest = {
	scopes: ['openid', 'profile', 'email'],
	prompt: 'select_account',
};

/**
 * Request object for acquiring tokens
 */
export const tokenRequest = {
	scopes: [process.env.REACT_APP_API_SCOPE || ''],
	forceRefresh: false,
};

/**
 * Default API scope for authenticating user
 */
export const apiScopes = [process.env.REACT_APP_API_SCOPE || ''];

export default msalConfig;
